import { render, staticRenderFns } from "./MarkdownShow.vue?vue&type=template&id=26fcc38c&scoped=true"
import script from "./MarkdownShow.vue?vue&type=script&lang=js"
export * from "./MarkdownShow.vue?vue&type=script&lang=js"
import style0 from "./MarkdownShow.vue?vue&type=style&index=0&id=26fcc38c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fcc38c",
  null
  
)

export default component.exports